import React, { useEffect } from 'react';
import swal from 'sweetalert';

const AppPaymentFail = () => {
  // useEffect(() => {
  //   // Show the SweetAlert as an informational message on page load
  //   swal({
  //     title: "Payment Cancelled",
  //     text: "Your payment has been cancelled.",
  //     icon: "error", // Info icon
  //     button: "OK",
  //   });
  // }, []);

  return (
    <div>
      {/* This component doesn't need to render anything special */}
    </div>
  );
};

export default AppPaymentFail;
